export default {
      id: "lobby-usage",
      viewBox: "0 0 200 150",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#lobby",
      toString: function () {
        return this.url;
      }
    }